import * as React from 'react';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import * as paths from '../paths';
import furoApi from '../api/FuroApi';
import GlobalErrorHandler from '../common/GlobalErrorHandler';
import './App.css';
import accountProvider from '../account/AccountProvider';
import ApplicationContextProvider, {ApplicationContextConsumer} from './ApplicationContext';
import LoadingOverlay from '../common/LoadingOverlay';
import AppHeader from './AppHeader';
import AppSlider from './AppSlider';
import AppRoutes from './AppRoutes';
import AppFooter from './AppFooter';
import moment from "moment";
import huHU from 'antd/es/locale/hu_HU';
import {ConfigProvider} from "antd";
import 'moment/locale/hu';
import {GlobalAlertContextProvider} from "./alert/GlobalAlertContextProvider";

moment.locale('hu');

class App extends React.Component<RouteComponentProps, {}> {

    constructor(props: RouteComponentProps) {
        super(props);
        furoApi.globalErrorHandler = new GlobalErrorHandler({
            logoutAction: this.logoutAction,
        });
    }

    public render() {
        return (
            <ConfigProvider locale={huHU}>
                <ApplicationContextProvider>
                    <ApplicationContextConsumer>
                        {({loadingHandler}) => (
                            <>
                                <LoadingOverlay visible={loadingHandler.isLoading()}/>
                                <GlobalAlertContextProvider>
                                    <div id="app-layout">
                                        <AppHeader/>
                                        <AppSlider onLogout={this.logoutAction}/>
                                        <div id="app-content">
                                            <AppRoutes/>
                                        </div>
                                        <AppFooter/>
                                    </div>
                                </GlobalAlertContextProvider>
                            </>
                        )}
                    </ApplicationContextConsumer>
                </ApplicationContextProvider>
            </ConfigProvider>
        );
    }

    private logoutAction = () => {
        // TODO some nicer way to do this without triggering the 'component unmounted before async tasks finished' warning
        setTimeout(() => {
            accountProvider.clearAccountStorage();
            this.props.history.replace(paths.loginPath);
        });
    };

}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/app/App.tsx